export const RESET_REPORTING_SETTINGS = 'RESET_REPORTING_SETTINGS';

export const resetReportingSettings = (id, title, report) => ({
  type: RESET_REPORTING_SETTINGS,
  id,
  title,
  report,
});
